import { useEffect } from "react";
import type { ProjectManifest } from "@pix/shared";
import { CHARA_POSITION_LABEL, type CharaPosition } from "../grid/gridTypes";

interface Props {
  manifest: ProjectManifest;
  position: CharaPosition;
  currentId: string | null;
  currentExpression: string | null;
  /** id=null は「このスロットをクリア」 */
  onSelect: (id: string | null, expression: string) => void;
  onCancel: () => void;
}

export function CharaPicker({
  manifest,
  position,
  currentId,
  currentExpression,
  onSelect,
  onCancel,
}: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  const characters = manifest.characters ?? {};
  const entries = Object.entries(characters);

  return (
    <div className="modal-backdrop" onMouseDown={onCancel}>
      <div className="modal modal-picker" onMouseDown={(e) => e.stopPropagation()}>
        <h2>
          立ち絵を選択
          <span className="modal-sub">({CHARA_POSITION_LABEL[position]})</span>
        </h2>

        {entries.length === 0 ? (
          <div className="picker-empty">
            manifest の characters にキャラクターが登録されていません。
          </div>
        ) : (
          <div className="chara-picker-list">
            {entries.map(([id, def]) => (
              <div key={id} className="chara-picker-group">
                <div
                  className="chara-picker-name"
                  style={{ color: def.defaultColor ?? "#ffd28a" }}
                >
                  {def.name}
                  <span className="chara-picker-id">({id})</span>
                </div>
                <div className="chara-picker-expressions">
                  {(def.expressions ?? []).map((exp) => (
                    <button
                      key={exp}
                      className={
                        "chara-picker-exp" +
                        (currentId === id && currentExpression === exp ? " active" : "")
                      }
                      onClick={() => onSelect(id, exp)}
                      title={`${id} / ${exp}`}
                    >
                      {exp}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="modal-actions modal-actions-spread">
          {currentId && (
            <button
              className="btn btn-warn"
              onClick={() => onSelect(null, "")}
            >
              このスロットをクリア
            </button>
          )}
          <button className="btn btn-secondary" onClick={onCancel}>
            キャンセル
          </button>
        </div>
      </div>
    </div>
  );
}
